import { FC } from 'react'
import classNames from 'classnames'

import { T } from '@web-solutions/module-localization'
import { Text } from '@web-solutions/core/ui-elements'
import { cacheImagesCascade } from '@web-solutions/core/utils/images'

import { tKey } from '../../constants'
import { useSpecialOfferTimer } from '../../hooks'

import { IMAGES } from './images'
import styles from './style.module.scss'

cacheImagesCascade([IMAGES.GIFT])

interface SpecialOfferDiscountBoardProps {
  prevDiscount: number
  discount: number
  className?: string
}

export const SpecialOfferDiscountBoard: FC<SpecialOfferDiscountBoardProps> = ({ prevDiscount, discount, className }) => {
  const { shown } = useSpecialOfferTimer();

  return shown && (
    <div className={classNames(styles.section, className)}>
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img src={IMAGES.GIFT.src} srcSet={IMAGES.GIFT.srcSet} alt='gift' />
        </div>
        <div>
          <Text className={styles.prevDiscount}><T k={`${tKey}.discount_board.prev_discount`} tOptions={{ prevDiscount }} ></T></Text>
          <Text className={styles.currentDiscount}><T k={`${tKey}.discount_board.discount`} tOptions={{ discount }} ></T></Text>
        </div>
      </div>
    </div>
  )
}
